// src/api/stateApi.js
// App state persistence — load and save user state via backend.

import apiClient from "./apiClient";

// Load saved state on login
export async function loadState() {
  const response = await apiClient.get("/api/state");
  return response.data;
}

// Save state — called on every change (debounced by MspOs.js)
export async function saveState(state) {
  const response = await apiClient.put("/api/state", state);
  return response.data;
}

// ── Todos (mobile) — read/write the same per-user state blob as the web app ──

// Open + done todos from the user's saved state
export async function getTodos() {
  const response = await apiClient.get("/api/state/todos");
  return response.data.todos || [];
}

// Flip a todo's done flag; returns the updated todos array
export async function toggleTodo(id) {
  const response = await apiClient.patch(`/api/state/todos/${id}/toggle`);
  return response.data.todos || [];
}

// Add a new manual todo (title only); returns the created todo
export async function addTodo(title) {
  const response = await apiClient.post("/api/state/todos", { title });
  return response.data.todo;
}
